export const availableCurrencies = [
  { id: 1, name: 'USD, EUR' },
  { id: 2, name: 'BYN' },
  { id: 0, name: 'RUB' },
];

export default availableCurrencies;
